import React from "react";

import InstaIcon from "../../images/insta_icon.svg";
import LinkedInIcon from "../../images/linkedIn_icon.svg";
import TwitterIcon from "../../images/twitter_icon.svg";
import FbIcon from "../../images/fb_icon.svg";
import TelegramIcon from "../../images/telegram_icon.svg";
import TiktokIcon from "../../images/tiktok_icon.svg";
import WhatsAppIcon from "../../images/whatsApp_icon.svg";

import { SocialLinksContainer } from "../../components/styles";

const SocialLinks = () => {
  const socialMedia = [
    { icon: InstaIcon, alt: "Instagram link", link: "#" },
    { icon: LinkedInIcon, alt: "LinkedIn link", link: "#" },
    { icon: TwitterIcon, alt: "Twitter link", link: "#" },
    { icon: FbIcon, alt: "Facebook link", link: "#" },
    { icon: TelegramIcon, alt: "Telegram link", link: "#" },
    { icon: TiktokIcon, alt: "TikTok link", link: "#" },
    { icon: WhatsAppIcon, alt: "Whats app link", link: "#" },
  ];
  return (
    <SocialLinksContainer>
      {socialMedia.map((item) => {
        return (
          <a href={item.link} key={item.alt} style={{ marginRight: 24 }}>
            <img src={item.icon} alt={item.alt} />
          </a>
        );
      })}
    </SocialLinksContainer>
  );
};

export default SocialLinks;
